import "./App.css";
import Cover from "./components/cover";
import PersonalInfo from "./components/personalInfo";
import Functions from "./components/functions";
import Contact from "./components/contact";
import Social from "./components/social";
import Button from "./components/button";
import { saveVCard, saveVCardAndroid } from "./utils/functions";
import axios from "axios";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import Loading from "./assets/loading.json";
import { isAndroid } from "react-device-detect";

// {
//   "email":"admin@property.tech",
//   "password":"?S2%wD7~3w[V<+<h"
// }

axios.defaults.headers.Accept = "*/*";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Headers"] = "*";
axios.defaults.headers["Access-Control-Allow-Credentials"] = "false";
axios.defaults.headers["Access-Control-Allow-Methods"] = "*";
axios.defaults.headers["withCredentials"] = false;

function App() {
  // const [data, setData] = useState({
  //   id: 4,
  //   name: "Dave",
  //   surname: "Schoonbrood",
  //   username: "dschoonbrood",
  //   postCode: null,
  //   country: null,
  //   city: null,
  //   county: null,
  //   street: null,
  //   companyEmail: null,
  //   linkedinUrl: "https://www.linkedin.com/in/daveschoonbrood/",
  //   note: null,
  //   email: "dschoonbrood@property.tech",
  //   phone: "+31 6 22551455",
  //   companyPhone: "",
  //   organization: "Property Technology Solutions",
  //   title: "Co-founder & Managing Director",
  //   link: "property.tech",
  //   status: 1,
  // });
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .post("https://qrbackend.ptslab.io/Auth/login", {
        email: "admin@property.tech",
        password: "?S2%wD7~3w[V<+<h",
        isEmail: true,
      })
      .then((res) => {
        console.log("res =>", res);
        const username =
          window.location.href.split("/")[
            window.location.href.split("/").length - 1
          ];
        axios
          .get(
            "https://qrbackend.ptslab.io/Customer/getbyusername?username=" +
              username,
            {
              headers: {
                Authorization: "Bearer " + res.data.token,
              },
            }
          )
          .then((res) => {
            console.log("res =>", res);
            setData(res.data);
          })
          .catch((error) => {
            setError(true);
          });
      });
  }, []);

  if (!data && !error)
    return (
      <div
        style={{
          backgroundColor: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          height: "100vh",
        }}
      >
        <Lottie animationData={Loading} style={{ width: 300, height: 200 }} />
      </div>
    );

  // if (error) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         flex: 1,
  //         height: "100vh",
  //       }}
  //     >
  //       <div>
  //         <span style={{ color: "black" }}></span>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div id="wrapper" style={{ height: "100vh" }}>
      <Cover data={data} error={error} />
      {error && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100vh",
          }}
        >
          <span style={{ color: "black", textAlign: "center" }}>
            The person you are try to access is cannot be loaded right
            now,please try to reload the page.
          </span>
        </div>
      )}
      {!error && <PersonalInfo data={data} error={error} />}
      {!error && <Functions data={data} error={error} />}
      {!error && <Contact data={data} error={error} />}
      {!error && <Social data={data} error={error} />}
      {!error && (
        <div
          className="saveButton"
          onClick={() => {
            if (isAndroid) {
              saveVCardAndroid(data);
            } else {
              saveVCard(data);
            }
          }}
        >
          Save Contact
        </div>
      )}
    </div>
  );
}

export default App;
